{
    "email": "Your email",
    "choose_pass": "Choose password",
    "confirm_pass": "Confirm password",
    "passwords_mismatch": "Passwords do not match.",
    "passwords_match": "Passwords are identical.",
    "success": "Password updated successfully !",
    "validator": {
        "uppercase": "Uppercase",
        "lowercase": "Lowercase",
        "figure": "Digit",
        "special_character": "Special char.",
        "size": "Size (min. 12)"
    }
}